Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContainer = void 0;
var _useSpacing2 = require("./useSpacing");
var _useSizing2 = require("./useSizing");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var _baseSize = require("../../baseSize");
var _getREM = require("../../getREM");
var useContainer = exports.useContainer = function useContainer() {
  var _useSpacing = (0, _useSpacing2.useSpacing)(),
    spacing = _useSpacing.spacing;
  var _useSizing = (0, _useSizing2.useSizing)(),
    sizing = _useSizing.sizing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var container = {
    paddingRight: spacing.page.padding.paddingRight,
    paddingLeft: spacing.page.padding.paddingLeft,
    marginBottom: spacing.xxxl,
    width: '100%'
  };
  var container_noHeader = {
    marginTop: (0, _getREM.getREM)((sizing.topBarHeight + insets.top) / _baseSize.baseSize),
    paddingTop: spacing.m
  };
  return {
    container: container,
    container_noHeader: container_noHeader
  };
};